import { apiClient } from "./client";

const GetStructureByHotelId = (id) => {
  return apiClient
    .get("/HotelStructure/GetStructureByHotelId", {
      params: {
        'hotelId': id
      }
    });
}

const Add = (data) => {
  return apiClient.post('/HotelStructure', {
    "hotelId": data.hotelId,
    "code": data.code
  }
  )
}

const AutoDesignHotelStructure = (data) => {
  return apiClient.post('/HotelStructure/AutoDesignHotelStructure', {
    "hotelStructureId": data.hotelStructureId,
    'numberOfFloor': data.numberOfFloor,
    'numberOfRooms': data.numberOfRooms,
    "bedCount": data.bedCount
  })
}

const HotelStrutureDropDown = (hotelId) => {
  return apiClient
    .get("/HotelStructure/HotelStrutureDropDown", {
      params: {
        'hotelId': hotelId
      }
    });
}

const GetHotelStructure = (Id) => {
  return apiClient
    .get("/HotelStructure/GetHotelStructure", {
      params: {
        'Id': Id
      },
    });
}

const PlanIdHotelStructureDropDown = (Id) => {
  return apiClient
    .get("/HotelStructure/PlanIdHotelStructureDropDown", {
      params: {
        'Id': Id
      }
    });
}

const PlanCodeHotelStructureDropDown = (Id) => {
  return apiClient
    .get("/HotelStructure/PlanCodeHotelStructureDropDown", {
      params: {
        'Id': Id
      }
    });
}

const SoftDelete = (id) => {
  return apiClient
    .delete("/HotelStructure", {
      params: {
        'Id': id
      }
    });
}


const GetPlanEditInfo = (planCode, hotelStructureId) => {
  return apiClient
    .get("/HotelStructure/GetPlanEditInfo", {
      params: {
        'planCode': planCode,
        'hotelStructureId': hotelStructureId
      }
    });
}

const hotelStructureApi = {
  GetStructureByHotelId, Add, AutoDesignHotelStructure, HotelStrutureDropDown, GetHotelStructure
  , PlanIdHotelStructureDropDown
  , PlanCodeHotelStructureDropDown
  , SoftDelete, GetPlanEditInfo
}

export default hotelStructureApi